<template>
	<div>
		<div class="title">{{ data.name}}</div>
		<div class="extra-list-warp">
			<template v-for="(item, index) in data.extra_list">
				<div class="extra-item" v-show="item['hide']===0" :key="index"
					:class="{ active: item.name == value.name }">
					<div @click="change(item)">
						<span>{{ item.name }}</span>
					</div>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
	import {
		getVal
	} from './util';

	export default {
		props: ['data', 'value'],
		mounted() {
			// 如果父级已设置值（通过initDefaults），跳过自动选中
			if (this.value && this.value.extra_sku) return;

			var list = this.data.extra_list;

			var active = list.find(d => d['is_default'] === 1);

			if (!active && this.data.name === "浓缩咖啡") {
				active = list.find(d => d['name'] === "标准");
			}

			if (!active && this.data.name === "萃取方式") {
				if (Array.isArray(list) && list.length > 0) {
					active = list[0];
				}
			}

			if (active) {
				this.change(active);
			}
		},
		methods: {
			change(item) {
				var val = getVal(this.data.name, item, this.data.code);

				//0非必选 1必选
				if (this.data.must == 0) {
					if (this.value["extra_sku"] === val["extra_sku"]) {
						this.$emit('input', {});
					} else {
						this.$emit('input', val);
					}
				} else {
					this.$emit('input', val)
				}
			}
		}
	};
</script>

<style lang="scss" scoped>
	.extra-list-warp {
		margin: 0 -10px;
		display: flex;
		flex-wrap: wrap;

		.extra-item {
			width: 33.33333%;
			padding: 10px;

			&>div {
				width: 100%;
				height: 100%;
				padding: 20px 10px;
				text-align: center;
				border-radius: 8px;

				font-size: 24px;
				border: 1px solid #f1f1f1;
				color: #999;

				display: flex;
				align-items: center;
				justify-content: center;
				transition: all 0.3s;
			}

			&.active>div {
				border-color: #f1f1f1;
				background: #f1f1f1;
				font-weight: bold;
				color: #333;
			}
		}
	}
</style>
